import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';

import { Button, Text, useTheme } from '@/components/ui';
import { useApi } from '@/hooks/use-api';
import { useAuth } from '@/hooks/use-auth';
import { spacing } from '@/styles/theme';

export const ImpersonationBanner: React.FC = () => {
	const theme = useTheme();
	const { user: currentUser } = useApi();
	const { isImpersonating, endImpersonation } = useAuth();

	// Only show banner on web/desktop, not on mobile
	if (!isImpersonating() || !currentUser || Platform.OS !== 'web') {
		return null;
	}

	const handleEndImpersonation = async () => {
		try {
			await endImpersonation();
		} catch (error) {
			console.error('Failed to end impersonation:', error);
		}
	};

	return (
		<View style={[styles.banner, { backgroundColor: theme.colors.errorContainer }]}>
			<View style={styles.content}>
				<View style={styles.textContainer}>
					<Text style={[styles.title, { color: theme.colors.onErrorContainer }]}>
						Impersonating User
					</Text>
					<Text style={[styles.subtitle, { color: theme.colors.onErrorContainer }]}>
						You are currently viewing the app as: {currentUser.name} ({currentUser.email})
					</Text>
				</View>
				<Button
					mode="contained"
					onPress={handleEndImpersonation}
					style={styles.button}
					buttonColor={theme.colors.error}
					textColor={theme.colors.onError}
				>
					End Impersonation
				</Button>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	banner: {
		paddingHorizontal: spacing.m,
		paddingVertical: spacing.s,
		borderBottomWidth: 1,
		borderBottomColor: 'rgba(0, 0, 0, 0.1)',
	},
	content: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	textContainer: {
		flex: 1,
		marginRight: spacing.m,
	},
	title: {
		fontSize: 16,
		fontWeight: '600',
		marginBottom: 2,
	},
	subtitle: {
		fontSize: 14,
		opacity: 0.8,
	},
	button: {
		paddingHorizontal: spacing.m,
		paddingVertical: spacing.xs,
	},
});
